__turbopack_context__.v({
  "panelMedVideo": "CustomComponent-module__KMYrHq__panelMedVideo",
  "sikkerhetNokkeltall": "CustomComponent-module__KMYrHq__sikkerhetNokkeltall",
  "style": "CustomComponent-module__KMYrHq__style",
  "tekst": "CustomComponent-module__KMYrHq__tekst",
});
